import styled from 'styled-components';

export const ContLayout = styled.div`
  width: 100%;
  height: auto;
  background-color: #FBFFFF;
`
